$(function () {
    $(".slider-services").each(function () {
        var slider = $(this).find('.slider-services-items');
        slider.slick({
            fade: false,
            dots: false,
            infinite: false,
            slidesToShow: 4,
            variableWidth: true,
            slidesToScroll: 1,
            prevArrow: slider.closest('.slider-services').find('.sliderPrevButton'),
            nextArrow: slider.closest('.slider-services').find('.sliderNextButton')
        });
    })
});